<template>
  <div class="gallery-field my-4 px-0" v-intersect.once="onIntersect">
    <h2>Menu Image Gallery</h2>
    <draggable
      v-model="localImages"
      v-if="localImages.length"
      handle=".handle"
      animation="200"
    >
      <transition-group tag="div" class="layout row wrap" name="gallery-list">
        <v-col
          cols="12"
          sm="6"
          v-for="(img, i) of localImages"
          :key="`gallery-img-${i}-${img.url}`"
        >
          <ImageFieldCard
            :img="img"
            @update="updateItemDetail(i, $event)"
            @delete="deleteImg(img)"
            @itemSelected="updateItemSelection(i, $event)"
            :can-move="localImages.length > 1"
            :allow-caption="true"
            allow-item-link
          />
        </v-col>
      </transition-group>
    </draggable>
    <UploadWidget
      @uploaded="addImagesToGallery"
      :disabled="localImages.length >= 4"
      :limit="4"
      :files="localImages"
    />
  </div>
</template>

<script>
import { mapActions, mapGetters } from 'vuex'
import { mapFields } from 'vuex-map-fields'
import Lambda from '@/services/Lambda'
import ImageFieldCard from '@/components/ImageFieldCard'
import UploadWidget from '@/components/UploadWidget'
import draggable from 'vuedraggable'

export default {
  name: 'GalleryField',
  props: {
    imgs: {
      type: Array,
      default: () => [],
    },
    settingName: {
      type: String,
      default: null,
    },
  },
  components: { ImageFieldCard, draggable, UploadWidget },
  data() {
    return {
      localImages: null,
    }
  },
  computed: {
    ...mapFields('auth', ['token']),
    ...mapGetters('shop', ['getShopId']),
    gallery: {
      get() {
        return this.imgs
      },
      set(value) {
        this.$emit('update', JSON.stringify(value))
        this.$emit('dirtied')
      },
    },
  },
  created() {
    this.localImages = this.imgs
  },
  methods: {
    ...mapActions('itemAndSection', ['fetchItems']),
    addImagesToGallery(imageArray) {
      let galleryUpdate = [...this.localImages, ...imageArray]
      this.localImages = galleryUpdate
      this.$emit('update', JSON.stringify(this.localImages))
    }, // addImagesToGallery

    updateItemDetail(index, { key, val }) {
      this.localImages[index][key] = val
      this.$emit('update', JSON.stringify(this.localImages))
      this.$emit('dirtied')
    }, // updateItemDetail

    updateItemSelection(index, itemSelection) {
      this.localImages[index].item = itemSelection
      this.$emit('update', JSON.stringify(this.localImages))
      this.$emit('dirtied')
    }, // updateItemSelection

    async deleteImg(img) {
      let deleted = await Lambda.post(
        'asset_delete',
        {
          public_id: img.public_id,
          settingName: this.settingName,
          token: this.token,
          shopId: this.getShopId,
        },
        { timeout: 10000 }
      )
      if (deleted) {
        let newGallery = this.localImages.filter(
          (i) => i.public_id !== img.public_id
        )
        this.localImages = newGallery
      }
    }, // deleteImg

    onIntersect(entries) {
      // More information about these options
      // is located here: https://developer.mozilla.org/en-US/docs/Web/API/Intersection_Observer_API
      let isIntersecting = entries[0].isIntersecting
      if (isIntersecting) {
        this.fetchItems()
      }
    }, // onIntersect
  }, // methods
}
</script>

<style lang="scss" scoped>
.gallery-list-enter-active,
.gallery-list-leave-active {
  transition: all 0.4s;
}
.gallery-list-enter, .gallery-list-leave-to /* .list-leave-active below version 2.1.8 */ {
  opacity: 0.1;
  transform: translateX(10px);
}
</style>
